import { TYPE_STRING } from './input-types';

export const id = 'internalNotes';
export const apiKey = 'InternalNotes';
export const type = TYPE_STRING;

export const internalNotes = {
  id,
  apiKey,
  type,
};
